import remove from '../../static/icons/actions/ic_remove_circle_24.svg';
import removeHover from '../../static/icons/actions/ic_remove_circle_filled_24.svg';
import checked from '../../static/icons/backstage/ic_check_circle_filled_24.svg';
import more from '../../static/icons/backstage/ic_more_circle_24.svg';
import pause from '../../static/icons/backstage/ic_pause_circle_48.svg';
import play from '../../static/icons/backstage/ic_play_circle_48.svg';
import addToCollection from '../../static/icons/ic_add_circle_24.svg';
import add24 from '../../static/icons/ic_add_thick_24.svg';
import chevronDown from '../../static/icons/ic_chevron_down_16.svg';
import chevron from '../../static/icons/ic_chevron_forward.svg';
import chevronUp from '../../static/icons/ic_chevron_up_16.svg';
import close from '../../static/icons/ic_close_24.svg';
import edit from '../../static/icons/ic_edit_circle_24.svg';
import fbShare from '../../static/icons/ic_facebook_24.svg';
import link from '../../static/icons/ic_link_24.svg';
import menu from '../../static/icons/ic_menu_24.svg';
import noPlay from '../../static/icons/ic_no_play_circle_24.svg';
import pause24 from '../../static/icons/ic_pause_24.svg';
import play24 from '../../static/icons/ic_play_24.svg';
import addToPlaylist from '../../static/icons/ic_playlist_circle_24.svg';
import question from '../../static/icons/ic_question_circle_24.svg';
import share from '../../static/icons/ic_share_circle_24.svg';
import stationShuffle from '../../static/icons/ic_shuffle_24.svg';
import shuffle from '../../static/icons/ic_shuffle_circle_24.svg';
import wand from '../../static/icons/ic_similar_songs_24.svg';
import station from '../../static/icons/ic_station_24.svg';
import createStationArtist from '../../static/icons/ic_station_artist_24.svg';
import createStation from '../../static/icons/ic_station_circle_24.svg';
import createStationTrack from '../../static/icons/ic_station_song_24.svg';
import twitterShare from '../../static/icons/ic_twitter_24.svg';
import twitter from '../../static/icons/logo-circle-twitter.svg';

export const SourceCardIcons = Object.freeze({
  addToCollection,
  addToPlaylist,
  openInDesktopApp: share,
  createStation,
  startStationArtist: createStationArtist,
  startStationTrack: createStationTrack,
  startStation: createStation,
  editStation: edit,
  share,
  chevron,
  removeFromCollection: { default: remove, hover: removeHover },
  removeFromPlaylist: { default: remove, hover: removeHover },
  deletePlaylist: { default: remove, hover: removeHover },
  deleteStation: { default: remove, hover: removeHover },
  delete: { default: remove, hover: removeHover },
  tired: noPlay,
  whySelected: question,
} as const);

export const ButtonRowIcons = Object.freeze({
  addToCollection,
  deletePlaylist: { default: checked, hover: removeHover },
  deleteStation: { default: checked, hover: removeHover },
  removeFromCollection: { default: checked, hover: removeHover },
  shuffle,
  createStation,
  play,
  pause,
  share,
  more,
  edit,
  playStation: play,
} as const);

export const interactiveIcons = Object.freeze({
  chevronUp,
  chevronDown,
  menu,
  close,
  clear: close,
} as const);

export const ButtonT3Icons = Object.freeze({
  play: play24,
  station,
  wand,
  add: add24,
  pause: pause24,
  shuffle: stationShuffle,
  twitter,
  fbShare,
  twitterShare,
  link,
} as const);

export const IconSizes = Object.freeze({
  small: 'small',
  large: 'large',
  xlarge: 'xlarge',
} as const);
